export default __webpack_public_path__ + "fdbce91a2c6a4bc66202a0a8fa3d9f77.svg";